import React, { useState } from "react";
import * as styles from "./PhotoGallery.module.css";
import { ComponentProps, ComponentWidth, Image } from "../../../types";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import Modal from "react-modal";
import CloseButton from "../../elements/CloseButton/CloseButton";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";

interface Props extends ComponentWidth, ComponentProps {
  title: string;
  description: string;
  photoGallery: Image[];
}

export const PhotoGallery: React.FC<Props> = ({
  title,
  description,
  photoGallery,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeImageIdx, setActiveImageIdx] = useState(0);

  const handleImageClick = (idx: number) => {
    setModalOpen(true);
    setActiveImageIdx(idx);
  };

  const handleCarouselClick = (dir: "fwd" | "back") => {
    if (dir === "fwd") {
      setActiveImageIdx(activeImageIdx + 1);
    }

    if (dir === "back") {
      setActiveImageIdx(activeImageIdx - 1);
    }
  };
  return (
    <section className={styles.photogallery}>
      <div className={styles.photoGallery} id="gallery">
        <div className={styles.galleryContent}>
          <h2>{title}</h2>
          <p>{description}</p>
          <div className={styles.images} style={{}}>
            {photoGallery?.map((image, key) => {
              return (
                <div className={styles.image} key={`gallery-photo-${key}`}>
                  <button
                    onClick={() => handleImageClick(key)}
                    aria-label="View image in overlay"
                  >
                    <KontentImageElement
                      image={image.item}
                      alt={image.alt}
                      width={image.item.width > 500 ? 500 : image.item.height}
                      aspectRatio={image.item.width / image.item.height}
                    />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {photoGallery && photoGallery?.length > 0 && (
        <Modal
          isOpen={modalOpen}
          preventScroll={true}
          appElement={
            typeof document === "undefined" ? undefined : document?.body
          }
          shouldCloseOnEsc={true}
          onRequestClose={() => setModalOpen(false)}
          style={{
            overlay: {
              zIndex: 1000,
              background: "#1F5C40CB",
              color: "#fff",
            },
            content: {
              inset: 0,
              width: "100%",
              border: "none",
              borderRadius: 0,
              background: "transparent",
              textAlign: "center",
            },
          }}
        >
          <div className={styles.carousel}>
            <div className={styles.modalCloseButton}>
              <CloseButton
                color="#fff"
                onClick={() => setModalOpen(false)}
                size={24}
              />
            </div>
            {photoGallery[activeImageIdx] && (
              <div className={styles.carouselImage}>
                <KontentImageElement
                  image={photoGallery[activeImageIdx].item}
                  alt={photoGallery[activeImageIdx].alt}
                  className={styles.modalImage}
                />
                {photoGallery[activeImageIdx]?.caption && (
                  <CustomRichTextElement
                    content={photoGallery[activeImageIdx].caption}
                  ></CustomRichTextElement>
                )}
              </div>
            )}
            <div className={styles.left}>
              <button
                onClick={(event) => handleCarouselClick("back")}
                aria-label={"Previous image"}
                disabled={activeImageIdx === 0}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  data-name="211647_right_chevron_icon"
                  viewBox="0 0 140.928 246.611"
                >
                  <path
                    fill="#fff"
                    d="M93.776 123.278 1.701 27.404a6.27 6.27 0 0 1 .11-8.7L18.277 1.853a5.969 5.969 0 0 1 8.535-.11l112.45 117.131a5.748 5.748 0 0 1 1.652 4.461 6.092 6.092 0 0 1-1.652 4.461L26.812 244.869a5.969 5.969 0 0 1-8.535-.11L1.811 227.908a6.27 6.27 0 0 1-.11-8.7Z"
                    data-name="211647_right_chevron_icon"
                  />
                </svg>{" "}
              </button>{" "}
            </div>
            <div className={styles.right}>
              <button
                onClick={(event) => handleCarouselClick("fwd")}
                aria-label="Next image"
                disabled={activeImageIdx === photoGallery.length - 1}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  data-name="211647_right_chevron_icon"
                  viewBox="0 0 140.928 246.611"
                >
                  <path
                    fill="#fff"
                    d="M93.776 123.278 1.701 27.404a6.27 6.27 0 0 1 .11-8.7L18.277 1.853a5.969 5.969 0 0 1 8.535-.11l112.45 117.131a5.748 5.748 0 0 1 1.652 4.461 6.092 6.092 0 0 1-1.652 4.461L26.812 244.869a5.969 5.969 0 0 1-8.535-.11L1.811 227.908a6.27 6.27 0 0 1-.11-8.7Z"
                    data-name="211647_right_chevron_icon"
                  />
                </svg>
              </button>{" "}
            </div>
          </div>
        </Modal>
      )}
    </section>
  );
};
